import { createApp } from 'vue'
import App from './App.vue'

// 注册 iconify 离线图标集
import { addCollection, type IconifyJSON } from '@iconify/vue'
import epIcons from '@iconify-json/ep/icons.json'
import mdiIcons from '@iconify-json/mdi/icons.json'
import phIcons from '@iconify-json/ph/icons.json'
addCollection(epIcons as IconifyJSON)
addCollection(mdiIcons as IconifyJSON)
addCollection(phIcons as IconifyJSON)

// UnoCSS reset
import '@unocss/reset/tailwind.css'
import 'virtual:uno.css'

// AOS 风格列表进入动画（v-aos 指令 + 表格行进入动画）
import '@/styles/aos.scss'

// reset style sheet
import '@/styles/reset.scss'
// CSS common style sheet
import '@/styles/common.scss'
// layout base
import '@/styles/layout.scss'
// iconfont css
import '@/assets/iconfont/iconfont.scss'
// font css
import '@/assets/fonts/font.scss'

// element plus
import ElementPlus from 'element-plus'
// element icons
import * as Icons from '@element-plus/icons-vue'
// element css (自定义主题色编译)
import '@/styles/element.scss'
// 运行时覆盖 Element Plus 主题色 CSS 变量
import '@/styles/theme-overrides.js'
// 全局 Element Plus 组件样式覆盖
import '@/styles/element-components.scss'
// custom element dark(自定义暗黑模式)
import '@/styles/theme/element-dark.scss'

// custom directives
import directives from '@/directives/index'
// vue Router
import router from '@/routers'
// vue i18n
import I18n from '@/i18n'
// pinia store
import pinia from '@/store/index'
// echarts
import '@/utils/echarts-register'
// echarts css / scss variables
import '@/styles/echarts-theme.scss'

// charts component library
import ChartsPlugin from '@/components/echarts/export'
import { usePermissionsStore } from '@/store/modules/user/permissions'
import { initLanguage } from '@/utils/lang'

// 全局禁用右键 -- 暂时注释by max
// document.addEventListener('contextmenu', (event) => {
//   event.preventDefault()
// })

const app = createApp(App)

app.use(pinia)

const permissionStore = usePermissionsStore()

// 刷新页面立刻恢复动态路由
permissionStore.initRoutesOnRefresh(router)

// 初始化语言（同步 vue-i18n / cache / html lang / dayjs）
initLanguage()

// 注册 element Icons 组件
Object.keys(Icons).forEach((key) => {
  app.component(key, Icons[key as keyof typeof Icons])
})

// 注册 charts 插件
app.use(ChartsPlugin)

app.use(router).use(I18n).use(directives).use(ElementPlus).mount('#app')
